import React, { useContext } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import "../../../App.css";
import Navbar from "../../ui/Navbar";
import { AuthContext } from "../../../context/AuthContext";

const CARDS = [
  {
    icon: "fa-solid fa-school",
    label: "Manage Institutes",
    description: "Add, edit, and configure all registered institutes",
    path: "/superadmin/manage-institutes",
    color: "#f09a21",
  },
  {
    icon: "fa-solid fa-file-contract",
    label: "Manage Terms",
    description: "Set and update terms & conditions for the platform",
    path: "/superadmin/manage-terms",
    color: "#da1c5c",
  },
  {
    icon: null,
    imgIcon: "/imgs/token_usage_icon.svg",
    label: "Usage Activity",
    description: "Monitor token consumption and usages ",
    path: "/superadmin/total-token-usage",
    color: "#d8db14",
  },
  {
    icon: "fa-solid fa-chart-pie",
    label: "Institute Stats",
    description: "View platform-wide statistics and analytics",
    path: "/superadmin/stats",
    color: "#3b82f6",
  },
  {
    icon: "fa-solid fa-file-lines",
    label: "Answer Papers",
    description: "See all answer papers with status",
    path: "/superadmin/answer-papers/all",
    color: "#a855f7",
  },
  {
    icon: "fa-solid fa-gears",
    label: "Batch Jobs",
    description: "Track background batch processing jobs",
    path: "/superadmin/batch-jobs/all",
    color: "#06b6d4",
  },
  {
    icon: "fa-solid fa-robot",
    label: "AI Config",
    description: "Configure AI models",
    path: "/superadmin/ai-config",
    color: "#ef4136",
  },
  {
    icon: "fa-solid fa-file-invoice-dollar",
    label: "Invoice Generator",
    description: "Generate  invoices for institutes",
    path: "/superadmin/invoice-generator",
    color: "#f59e0b",
  },
  {
    icon: "fa-solid fa-book",
    label: "Resources",
    description: "Upload and manage shared platform resources",
    path: "/superadmin/resources",
    color: "#10b981",
  },
  {
    icon: "fa-solid fa-book-open",
    label: "Library",
    description: "Create and manage MCQ libraries and extract questions from PDFs",
    path: "/superadmin/library",
    color: "#0f766e",
  },
  {
    icon: null,
    imgIcon: "/imgs/whatsapp_icon.svg",
    label: "WhatsApp",
    description: "Check Institutes WhatsApp Notification Usage",
    path: "/superadmin/whatsapp-notifications",
    color: "#25d366",
  },
  {
    icon: "fa-solid fa-list",
    label: "LOVs",
    description: "Manage list-of-values used across the platform",
    path: "/superadmin/lov-management",
    color: "#6366f1",
  },
  {
    icon: "fa-solid fa-circle-question",
    label: "FAQ",
    description: "Edit frequently asked questions for users",
    path: "/superadmin/faq",
    color: "#ec4899",
  },
  {
    icon: "fa-solid fa-circle",
    label: "OMR Templates",
    description: "Manage OMR templates",
    path: "/superadmin/omr-templates",
    color: "#7d3cffdd",
  },
  {
    icon: "fa-solid fa-chart-column",
    label: "OMR Stats",
    description: "View OMR template test creation and submission stats by institute",
    path: "/superadmin/omr-stats",
    color: "#8b5cf6",
  },
  {
    icon: "fa-solid fa-file-circle-check",
    label: "Standardized Tests",
    description: "Manage standardized test templates",
    path: "/superadmin/standardized-tests",
    color: "#0f766e",
  },
  {
    icon: "fa-solid fa-chart-line",
    label: "Library Stats",
    description: "Analyze student online test submissions & library standardized test usage",
    path: "/superadmin/library-stats",
    color: "#6366f1",
  },
  {
    icon: "fa-solid fa-award",
    label: "Certificate Templates",
    description: "Design and manage certificate templates with QR & Name placement",
    path: "/superadmin/manage-certificates",
    color: "#f09a21",
  },
  {
    icon: "fa-solid fa-screwdriver-wrench",
    label: "Maintenance Mode",
    description: "Schedule system maintenance windows and display live alerts",
    path: "/superadmin/manage-maintenance",
    color: "#da1c5c",
  },
];

export default function SuperAdminHome() {
  const { isAuthenticated, primaryRole, user } = useContext(AuthContext);
  const navigate = useNavigate();

  const breadcrumbs = [{ name: "Home", path: "/superadmin", isLast: true }];

  document.title = "GradeMe-AI: Super Admin Dashboard";

  if (!isAuthenticated || primaryRole !== "superadmin") {
    return <Navigate to="/login" replace />;
  }

  const showOnlyLibrary =
    user?.isMasterUser === true &&
    Array.isArray(user?.role) &&
    user.role.length === 1 &&
    user.role[0] === "superadmin";

  const displayedCards = showOnlyLibrary
    ? CARDS.filter(
        (card) =>
          card.path === "/superadmin/library" ||
          card.path === "/superadmin/library-stats"
      )
    : CARDS;

  return (
    <div className="super-admin-container">
      <Navbar pageName="GradeMe-AI Super Admin Panel" breadcrumbs={breadcrumbs} />

      <div className="sa-home-content">
        <div className="sa-cards-grid">
          {displayedCards.map((card) => (
            <button
              key={card.path}
              className="sa-card"
              onClick={() => navigate(card.path)}
              style={{ "--card-color": card.color }}
            >
              <div className="sa-card-icon-wrap">
                {card.imgIcon
                  ? <img src={card.imgIcon} alt={card.label} className="sa-card-img-icon" />
                  : <i className={card.icon}></i>
                }
              </div>
              <div className="sa-card-body">
                <h3 className="sa-card-label">{card.label}</h3>
                <p className="sa-card-desc">{card.description}</p>
              </div>
              <i className="fa-solid fa-chevron-right sa-card-arrow"></i>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
